import logo from "../../assets/logo.png";
import { useNavigate } from "react-router";
import { useTranslation } from "../../i18n/TranslationProvider";

const Brand = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <img
            className="w-48 cursor-pointer md:w-72 h-auto"
            src={logo}
            alt={t("brand.altText")}
            onClick={() => navigate("/")}
        />
    );
};

export default Brand;